import React from 'react';
import { X } from 'lucide-react';

export const splitAuthors = (autor) => (autor || '').split(/\s*;\s*/).map((a) => a.trim()).filter(Boolean);

const norm = (v) => (v || '').trim().toLowerCase();

export const matchesFacet = (book, facet) => {
  if (!facet) return true;
  if (facet.type === 'categoria') return norm(book.categoria) === norm(facet.value);
  return splitAuthors(book.autor).some((a) => norm(a) === norm(facet.value));
};

const linkStyle = (color) => ({ background: 'none', border: 'none', padding: 0, cursor: 'pointer', color: 'inherit', font: 'inherit', textAlign: 'left', display: 'inline',
  textDecoration: 'underline', textDecorationColor: `${color}66`, textUnderlineOffset: 3, transition: 'color 0.15s ease' });

const FacetLink = ({ label, onClick, color, testId }) => (
  <button type="button" data-testid={testId} title={`Ver todos os livros: ${label}`} style={linkStyle(color)}
    onMouseEnter={(e) => { e.currentTarget.style.color = color; }} onMouseLeave={(e) => { e.currentTarget.style.color = 'inherit'; }}
    onClick={(e) => { e.stopPropagation(); onClick(); }}>
    {label}
  </button>
);

export const AuthorLinks = ({ book, onFacet, color }) => {
  const authors = splitAuthors(book.autor);
  if (!authors.length) return '-';
  return authors.map((a, i) => (
    <React.Fragment key={a + i}>
      {i > 0 && '; '}
      <FacetLink label={a} color={color} onClick={() => onFacet({ type: 'autor', value: a })} testId={`author-link-${book.id}-${i}`} />
    </React.Fragment>
  ));
};

export const CategoryLink = ({ book, onFacet, color }) => (book.categoria?.trim()
  ? <FacetLink label={book.categoria.trim()} color={color} onClick={() => onFacet({ type: 'categoria', value: book.categoria.trim() })} testId={`category-link-${book.id}`} />
  : '-');

export const FacetChip = ({ facet, onClear, color }) => (
  <div data-testid="catalog-facet-chip" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', padding: '0.4rem 0.5rem 0.4rem 0.9rem',
    borderRadius: 50, background: `${color}18`, border: `1px solid ${color}55`, color: '#2D3748', fontSize: '0.88rem', maxWidth: '100%' }}>
    <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
      {facet.type === 'autor' ? 'Livros de' : 'Categoria'}: <strong>{facet.value}</strong>
    </span>
    <button type="button" onClick={onClear} data-testid="catalog-facet-clear" title="Remover filtro" aria-label="Remover filtro"
      style={{ background: color, color: 'white', border: 'none', borderRadius: 50, width: 22, height: 22, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', flexShrink: 0, padding: 0 }}>
      <X className="w-3.5 h-3.5" />
    </button>
  </div>
);
